import { render, staticRenderFns } from "./CollectionsModal.vue?vue&type=template&id=7eacfcd0&scoped=true"
import script from "./CollectionsModal.vue?vue&type=script&lang=js"
export * from "./CollectionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eacfcd0",
  null
  
)

export default component.exports